<!-- V3-01: a 2-row GRID — row 1 is [chip column | title column | actions],
     row 2 is the description spanning the two text columns, and the actions
     cell spans BOTH rows. Master gave the bold title a column of its own
     (`fxFlex="30"` chip + `fxFlex="50"` title on FlyCuts, 40/60 on FlyPlates,
     see git show staging:src/app/vengreso/shortcuts/shortcuts.component.html);
     the flat flex ROW introduced at R9 had collapsed that into `[chip] [title]`
     inline, ~10px apart.
     R9 (kept, V4-02): the stats icon and the usage badge share a centerline
     with vng-expansion-panel's chevron, which the library renders as their flex
     sibling. Which line that is now follows master per host — line 1 on
     FlyCuts/FlyPlates, the two-line midpoint on the dashboard widget — and
     app.scss pulls the chevron up onto line 1 for collapsed rows the way
     master's `.mat-expansion-indicator { top: -20px }` did. See the SCSS. -->
<div class="flymsg-row-header">
  <div class="flymsg-row-header__top">
    <vng-checkbox
      *ngIf="showCheckbox"
      color="primary"
      [ngModel]="checked"
      (ngModelChange)="onCheckedChange($event)"
    ></vng-checkbox>

    <span class="flymsg-row-header__chip">{{ name }}</span>
    <!-- V3-01: master kept the PREMIUM badge in the chip column, right of the
         chip (templates.component.html, `fxFlex="40"`), not after the title. -->
    <strong *ngIf="premium" class="flymsg-row-header__premium">PREMIUM</strong>
  </div>

  <strong *ngIf="title && !titleHtml" class="flymsg-row-header__title">{{ title }}</strong>
  <strong *ngIf="titleHtml" class="flymsg-row-header__title" [innerHtml]="titleHtml"></strong>

  <div class="flymsg-row-header__description" *ngIf="!descriptionHtml">
    {{ description || descriptionPlaceholder }}
  </div>
  <div
    class="flymsg-row-header__description"
    *ngIf="descriptionHtml"
    [innerHtml]="descriptionHtml"
  ></div>

  <div class="flymsg-row-header__actions">
    <ng-template #statsPopover>
      <p class="flymsg-row-header__popover-label">Number of times used</p>
      <p class="flymsg-row-header__popover-value">{{ timesUsed || 0 }}</p>
      <p class="flymsg-row-header__popover-label">Time Saved</p>
      <p class="flymsg-row-header__popover-value">{{ timeSavedDisplay }} hours</p>
    </ng-template>
    <vng-icon
      *ngIf="showStats"
      name="signal_cellular_alt"
      [outline]="false"
      class="flymsg-row-header__stats-icon"
      [ngbPopover]="statsPopover"
      placement="top"
      triggers="mouseenter:mouseleave"
      (click)="statsClick.emit()"
    ></vng-icon>

    <div
      *ngIf="showUsageBadge"
      class="flymsg-row-header__usage-badge"
      [vngTooltip]="usageLabel + ' (' + (usageCount || 0) + ')'"
      vngTooltipPosition="top"
      (click)="usageClick.emit()"
    >
      <img src="assets/images/Clock.png" alt="" />
      <span>{{ usageCount || 0 }}</span>
    </div>
  </div>
</div>

<!-- Row-level error (Import FlyCuts preview). Sits OUTSIDE the grid so hosts
     that never set `errorText` keep the exact two-row header they had. -->
<p class="flymsg-row-header__error" *ngIf="errorText">
  <img src="assets/images/warning.png" alt="" />
  <span>{{ errorText }}</span>
</p>
